import clsx from "clsx";
import { memo, useMemo } from "react";

import { FastButton } from "@fastFields/fastButton";
import { IButtonModeEnum } from "@molecules/button";
import { usePageMode } from "@stores/uiStore";

import classes from "./styles.module.scss";

import type { IFormButtonsProps } from "@organisms/formButtons/types";

export const FormButtons = memo(function FormButtons({
  cancelButtonProps,
  submitButtonProps,
  customButtons,
  noCancel,
  noSubmit,
  isLoading,
  noBack,
}: IFormButtonsProps) {
  const mode = usePageMode();

  const customButtonsList = useMemo(
    () =>
      customButtons?.map((button) => (
        <FastButton
          className={clsx(classes.button)}
          key={button.key || button?.type}
          {...button}
        />
      )),
    [customButtons],
  );

  return (
    <div className={clsx(classes.container)}>
      {customButtons ? (
        <>{customButtonsList}</>
      ) : (
        <>
          {!noCancel && (
            <FastButton
              className={clsx(classes.button)}
              type={noBack || mode === "create" ? "cancelAndBack" : "back"}
              {...cancelButtonProps}
            />
          )}
          {!noSubmit && (
            <FastButton
              className={clsx(classes.button)}
              isLoading={isLoading}
              type={"saveAndSend"}
              mode={IButtonModeEnum.Submit}
              {...submitButtonProps}
            />
          )}
        </>
      )}
    </div>
  );
});
FormButtons.displayName = "FormButtons";
